import { render, staticRenderFns } from "./ModalCostumersTOperador.vue?vue&type=template&id=040d40b0&scoped=true"
import script from "./ModalCostumersTOperador.vue?vue&type=script&lang=js"
export * from "./ModalCostumersTOperador.vue?vue&type=script&lang=js"
import style0 from "./ModalCostumersTOperador.vue?vue&type=style&index=0&id=040d40b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d40b0",
  null
  
)

export default component.exports